export const UpgadeCreatorIds = {
    /**
     * @constant
     * @type {string}
     */
    mineDamage: 'mineDamage',
    /**
     * @constant
     * @type {string}
     */
    mineOre: 'mineOre'
};
